export default __webpack_public_path__ + "static/media/googleplay_pt-br_badge_web.f78b2fd5.png";